import Mutations from '../../odata/mutations';

export default {
  ...new Mutations('previewNotifications'),
  ...new Mutations('notification'),
  ...new Mutations('notifications'),
};
